import { useCallback, useEffect, useRef, useState } from 'react';

export const useVoice = () => {
  const [speaking, setSpeaking] = useState(false);
  const queue = useRef([]);
  const active = useRef(null);
  const generation = useRef(0);
  const supported = typeof window !== 'undefined' && 'speechSynthesis' in window;
  const stop = useCallback(() => {
    generation.current += 1;
    queue.current = [];
    if ('speechSynthesis' in window) window.speechSynthesis.cancel();
    active.current = null;
    setSpeaking(false);
  }, []);
  const speak = useCallback((text) => {
    if (!supported) return false;
    stop();
    const token = generation.current;
    queue.current = text.replace(/[*#]/g, '').match(/[^.!?\n]+[.!?]?/g) || [text];
    setSpeaking(true);
    const next = () => {
      if (generation.current !== token) return;
      const chunk = queue.current.shift();
      if (!chunk) { setSpeaking(false); active.current = null; return; }
      const utterance = new SpeechSynthesisUtterance(chunk.trim());
      const voices = window.speechSynthesis.getVoices();
      const voice = voices.find(v => v.lang === 'en-US' && /Google|Samantha|Aria/.test(v.name));
      if (voice) utterance.voice = voice;
      utterance.rate = 0.95;
      utterance.onend = next;
      utterance.onerror = () => { if (generation.current === token) { setSpeaking(false); queue.current = []; } };
      active.current = utterance;
      window.speechSynthesis.speak(utterance);
    };
    next();
    return true;
  }, [stop, supported]);
  useEffect(() => () => { generation.current += 1; if ('speechSynthesis' in window) window.speechSynthesis.cancel(); }, []);
  return { supported, speaking, speak, stop };
};